import { connect } from 'react-redux'
import { RecurringTripsPane } from '../../../components/riders/riderdetails/recurringTrips/RecurringTripsPane'
import { IActiveTripResponseV2, IStoreState, ITripFilters } from '../../../types'
import * as actions from '../../../state/actions/riders'
import * as tripActions from '../../../state/actions/trips'
import { actionCreators } from '../../../state/actions/google_map'
export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const orgId = state.organizations.currentOrgId
  return {
    riderId: ownProps.riderId,
    orgId,
    organizations: orgId ? state.organizations.items[orgId] : null,
    recurringTripsItems: state.riders.rider.riderRecurringTrips ? state.riders.rider.riderRecurringTrips.items : [],
    recurringTripsCount: state.riders.rider.riderRecurringTrips ? state.riders.rider.riderRecurringTrips.count : 0,
    destroyedRecurringTaskId: state.riders.rider.destroyedRecurringTaskId
      ? state.riders.rider.destroyedRecurringTaskId
      : ''
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    fetchTrips: (params: ITripFilters) => {
      return dispatch(tripActions.getManyTrips(params))
    },
    getRecuringTripByRiderId: (riderId: string): Promise<any> => {
      return dispatch(actions.getRecuringTripByRiderId(riderId))
    },
    destroyRecurringTripTask: (recurrinTripId: string) => {
      return dispatch(actions.destroyRecurringTripTask(recurrinTripId))
    },
    cloneTrip: async (trip: IActiveTripResponseV2) => {
      const tripClone = { ...trip }
      const pickup = {
        lat: trip.pickupLocation.latitude,
        lng: trip.pickupLocation.longitude
      }
      const dropoff = {
        lat: trip.dropoffLocation.latitude,
        lng: trip.dropoffLocation.longitude
      }
      // tripClone.scheduledDropoffTime = undefined
      return Promise.all([
        dispatch(tripActions.actionCreators.cloneTrip(tripClone)),
        dispatch(actionCreators.setOrigin(pickup)),
        dispatch(actionCreators.setDestination(dropoff)),
        dispatch(actionCreators.replaceMarkers('origin', [{ type: 'origin', lat: pickup.lat, lng: pickup.lng }])),
        dispatch(
          actionCreators.replaceMarkers('destination', [{ type: 'destination', lat: dropoff.lat, lng: dropoff.lng }])
        )
      ])
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecurringTripsPane)



// WEBPACK FOOTER //
// ./src/containers/riders/riderdetails/RecurringTripsPane.ts